import {AuthInfo, getAuthRedirectUrl} from '@financial/auth-node-package'
import {AxiosError, HttpStatusCode, isAxiosError} from 'axios'

export function isAuthError(error: AxiosError) {
    return isAuthErrorResponse(error.response?.data || {})
}

export function isAuthErrorResponse(response: unknown): response is AuthInfo {
    return response !== null && typeof response === 'object' && 'code' in response && 'memberInfo' in response
}

export function getRedirectUrlFromAuthError(error: unknown, currentUrl: string, isMobile: boolean): string | undefined {
    if (!isAxiosError(error) || !isAuthErrorResponse(error.response?.data || {})) {
        return undefined
    }
    const {code} = error.response?.data || {}
    return getAuthRedirectUrl({
        statusCode: error.response?.status || HttpStatusCode.Unauthorized,
        authCode: code,
        currentUrl,
        isMobile,
    })
}
